export default "__VITE_ASSET__DzMPZD1W__"